import axios from 'axios'

const reviewPurchaseSaleBook =  async function(id){
    try{
        const   path = `/acc_purchase_sale_book/${id}/review`
            ,   route = process.env.VUE_APP_API_ROUTE.concat( path )
            ,   response = await axios.post(route)
        return response.data
    }
    catch( error ) {
        return error.response.data
    }
}

export { reviewPurchaseSaleBook }
